/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveLPTokensMagician256,
  CurveLPTokensMagician256Interface,
} from "../CurveLPTokensMagician256";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidCurvePriceProviderLPTokenPair",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrNotSupportedLPToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "coin",
        type: "address",
      },
    ],
    name: "Cached",
    type: "event",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COINS",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolCoins",
    outputs: [
      {
        internalType: "address",
        name: "coin",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveLPTokensMagician256ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveLPTokensMagician256ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveLPTokensMagician256__factory extends ContractFactory {
  constructor(...args: CurveLPTokensMagician256ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveLPTokensMagician256";
  }

  deploy(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveLPTokensMagician256> {
    return super.deploy(
      _fetchersRepository,
      _priceProvidersRepository,
      overrides || {}
    ) as Promise<CurveLPTokensMagician256>;
  }
  getDeployTransaction(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _fetchersRepository,
      _priceProvidersRepository,
      overrides || {}
    );
  }
  attach(address: string): CurveLPTokensMagician256 {
    return super.attach(address) as CurveLPTokensMagician256;
  }
  connect(signer: Signer): CurveLPTokensMagician256__factory {
    return super.connect(signer) as CurveLPTokensMagician256__factory;
  }
  static readonly contractName: "CurveLPTokensMagician256";
  public readonly contractName: "CurveLPTokensMagician256";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensMagician256Interface {
    return new utils.Interface(_abi) as CurveLPTokensMagician256Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensMagician256 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensMagician256;
  }
}
